/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductImportViolation } from '../../models/product-import-violation';

export interface ValidateExcel$Params {

/**
 * The id (i.e path/name) of imported excel file to validate
 */
  key: string;

/**
 * The merchantId in case of EASYLOT_ADMIN
 */
  merchantIdParam?: string;
}

export function validateExcel(http: HttpClient, rootUrl: string, params: ValidateExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductImportViolation>>> {
  const rb = new RequestBuilder(rootUrl, validateExcel.PATH, 'get');
  if (params) {
    rb.path('key', params.key, {});
    rb.query('merchantIdParam', params.merchantIdParam, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProductImportViolation>>;
    })
  );
}

validateExcel.PATH = '/import/excels/{key}/validate';
